import fontSize from '../fontSize';
import fontWeight from '../fontWeight';
import fontFamily from '../fontFamily';
import lineHeight from '../lineHeight';
export default {
  size: fontSize,
  family: fontFamily,
  weight: fontWeight,
  lineHeight: lineHeight
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/font/index.js
// module id = 554
// module chunks = 12